import gql from "graphql-tag";

export default gql`query FileAddressBooks($id:Int!) {
    file(id:$id) {
        id    
        addressBooks {
            id      
            reference
            entity {
                id
                typeid
                name
            }
            employees {
                id
                entity {
                    id
                    name
                }
            }
        }
        team {
            id
            name
        }
        teamFuture {
            id
            name
        }
        propertyPrice {
            id
            body
        }
        panel {
            id
            panelno
        }
      }
  }`